import throttle from 'lodash/throttle'
import { useMemo } from 'react'
import { Button, ButtonProps } from './shadcn/button'

type ClickEvent = React.MouseEvent<HTMLButtonElement, MouseEvent>

export function ThrottledButton({
  onClick,
  ...props
}: Omit<ButtonProps, 'onClick'> & {
  onClick?: (event: ClickEvent) => void
}) {
  const throttledClick = useMemo(() => {
    if (!onClick) return undefined

    return throttle(
      (event: ClickEvent) => {
        onClick(event)
      },
      1000,
      { trailing: false },
    )
  }, [onClick])

  return <Button {...props} onClick={throttledClick} />
}
